/**
 * Returns a usable thumbnail URL. Sendbird can return placeholder query-only URLs.
 */
export const getSafeThumbnailUrl = (thumbnails = []) => {
  if (!Array.isArray(thumbnails) || thumbnails.length === 0) return "";
  const url = thumbnails[0]?.url || "";
  return url.startsWith("?") ? "" : url;
};

/**
 * Maps document mime type to an icon asset used in chat/media listings.
 */
export const getDocumentIconByMime = (mimeType = "") => {
  if (mimeType.includes("pdf")) {
    return require("assets/images/document-icon-pdf.svg").default;
  }
  if (mimeType.includes("wordprocessingml") || mimeType.includes("msword")) {
    return require("assets/images/document-icon-word.svg").default;
  }
  if (
    mimeType.includes("spreadsheetml") ||
    mimeType.includes("msexcel") ||
    mimeType.includes("ms-excel")
  ) {
    return require("assets/images/document-icon-excel.svg").default;
  }
  return require("assets/images/document-icon.svg").default;
};

export const openInNewTab = (url) => {
  if (!url) return;
  window?.open(url, "_blank");
};
